import { render, staticRenderFns } from "./SaldoAlocadoDia.vue?vue&type=template&id=1d9ec30a&scoped=true&"
import script from "./SaldoAlocadoDia.vue?vue&type=script&lang=js&"
export * from "./SaldoAlocadoDia.vue?vue&type=script&lang=js&"
import style0 from "./SaldoAlocadoDia.vue?vue&type=style&index=0&id=1d9ec30a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ec30a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
